import { Constant } from '../Actions/Constant'
const INITIAL_STATE = {
    data: [],
    overView:{}
}
export default (state = INITIAL_STATE, action) => {
    let data;
    switch (action.type) {
        case Constant.FETCHCATEGORYLIST:
            return ({
                ...state,
                data: action.payload.data.data,
            })
        case Constant.FETCHCATEGORYOVERVIEW:
            return ({
                ...state,
                overView: action.payload.data.data,
            })

        case Constant.ADDCATEGORY:
            data = state.data;
            data.unshift(action.payload)
            return ({
                ...state,
                data: data,
            })
        case Constant.DELETECATEGORY:
            data = state.data;
            let temp = data.filter(a => a.id != action.payload)
            return ({
                ...state,
                data: temp,
            })
        case Constant.UPDATECATEGORY:
            data = state.data;
            let index = data.findIndex(a => a.id == action.payload.data.id)
            data.splice(index, 1, action.payload.data)

            return ({
                ...state,
                data: data,
            })


        default:
            return state;

    }

}